<script setup lang="ts">
// Powłoka aplikacji. Cała aplikacja to planer z własnym układem (szyna, sidebar,
// pasek górny) — tu zostają tylko rzeczy globalne: silniki minutników i Pomodoro
// (odliczają na każdej podstronie) i potwierdzenie wpisu z dyktowania.
import { onMounted } from 'vue';
import 'primeicons/primeicons.css'
import AiEntryDialog from '@/components/v2/ai-entry-dialog.vue';
import ConfirmHost from '@/components/v2/confirm-host.vue';
import AiLimitNotice from '@/components/v2/ai-limit-notice.vue';

const { ensureEngine } = useTimers();
const { ensureEngine: ensurePomodoroEngine } = usePomodoro();

onMounted(() => { ensureEngine(); ensurePomodoroEngine(); });
</script>

<template>
  <div class="min-h-screen bg-[#FBF9F4]">
    <NuxtPwaManifest />

    <main>
      <NuxtPage />
    </main>

    <!-- Dyktowanie → formularz treningu / posiłku / snu do potwierdzenia -->
    <AiEntryDialog />

    <!-- Wspólne „czy na pewno" dla await confirm(…) z useConfirm -->
    <ConfirmHost />

    <!-- Wyczerpany limit AI (odpowiedź 429 „ai_limit") — jeden komunikat dla wszystkich funkcji AI -->
    <AiLimitNotice />
  </div>
</template>

<style>
body {
  font-family: 'Manrope', sans-serif;
  margin: 0;
  padding: 0;
}

/* Pasek podstron przewijany poziomo, ale bez widocznego scrollbara */
.no-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.no-scrollbar::-webkit-scrollbar {
  display: none;
}
</style>
